import { CsiImage, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";
import imageLS from "./LandscapeSmallImage.jpg";
import imagePS from "./PortraitSmallImage.jpg";

export default () => {
	return (
		<CssColumnGrid columns={1}>
			<Text semiBold text="landscape" />
			<CsiImage size="large" src={imageLS} />
			<Text semiBold text="portrait" />
			<CsiImage size="large" src={imagePS} />
		</CssColumnGrid>
	);
};